import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const OjetaSpravaPage = lazy(() =>
  import('@/modules/ojeta-vozidla/OjetaSpravaPage').then((m) => ({ default: m.OjetaSpravaPage })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ojeta-vozidla/sprava',
  component: () => (
    <Suspense fallback={null}>
      <OjetaSpravaPage />
    </Suspense>
  ),
});
